"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const styles_1 = __importDefault(require("../../styles/styles"));
const communicationBoxUtils_1 = __importDefault(require("../communicationBox/communicationBoxUtils"));
const StopWatch = ({ timeInSeconds }) => {
    const [time, setTime] = react_1.useState(timeInSeconds);
    react_1.useEffect(() => {
        // Add a second to the time for every 1000 milliseconds.
        const interval = setInterval(() => {
            setTime((prevTime) => prevTime + 1);
        }, 1000);
        return () => clearInterval(interval);
    }, []);
    const updateTime = communicationBoxUtils_1.default(time);
    return (react_1.default.createElement(react_native_1.View, { style: styles_1.default.alignCenterCenter },
        react_1.default.createElement(react_native_paper_1.Title, { style: [
                styles_1.default.textColorWhite,
                styles_1.default.marginTen,
                styles_1.default.fontSizeText,
                styles_1.default.textColorBlue,
            ] }, updateTime)));
};
exports.default = StopWatch;
